import type { PropertyTab } from "../types"

const TAB_LABELS: Record<PropertyTab, string> = {
  buy: "Buy",
  rent: "Rent",
  commercial: "Commercial",
}

type SearchTypeToggleProps = {
  tabs: PropertyTab[]
  active: PropertyTab
  onChange: (tab: PropertyTab) => void
}

export function SearchTypeToggle({ tabs, active, onChange }: SearchTypeToggleProps) {
  if (tabs.length <= 1) {
    return null
  }

  return (
    <div className="bpp-tabs" role="tablist" aria-label="Property search type">
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={tab === active}
          className={`bpp-tab${tab === active ? " is-active" : ""}`}
          onClick={() => onChange(tab)}
        >
          {TAB_LABELS[tab]}
        </button>
      ))}
    </div>
  )
}
